import { Box, Button, Typography, alpha, styled } from '@mui/material';
import { UnfoldLess } from '@mui/icons-material';
import { AdditionalColors } from '@gc-bridge/theme/colors';
import { RouterLink } from '@gc-bridge/components/RouterLink';
import { PageLinks } from '@gc-bridge/components/Footer/PageLinks';
import { MarshMcLennanIcon } from '@gc-bridge/components/Icons/MarshMcLennanIcon';
import { IconType } from '@gc-bridge/components/Icons/constants';

const Container = styled(Box)(() => ({
  backgroundColor: AdditionalColors.Honeydew,
  display: 'flex',
  justifyContent: 'space-between',
  height: '260px',
  boxSizing: 'border-box',
  paddingLeft: '40px',
  paddingRight: '40px',
  paddingTop: '40px',
}));

const LeftContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '30px',
}));

const StyledDescription = styled(Typography)(() => ({
  color: alpha(AdditionalColors.Black, 0.47),
  fontSize: '12px',
  fontWeight: 700,
  fontFamily: 'Arial',
}));

const StyledTypography = styled(Typography)(() => ({
  color: alpha(AdditionalColors.Black, 0.47),
  width: '236px',
  boxSizing: 'border-box',
  fontSize: '10px',
}));

const StyledLinkBox = styled(Box)(() => ({
  width: '600px',
  display: 'flex',
  justifyContent: 'space-between',
}));

const StyledLink = styled(RouterLink)(() => ({
  color: alpha(AdditionalColors.Black, 0.47),
  fontFamily: 'Arial',
  fontSize: '12px',
  fontWeight: 700,
  textDecoration: 'none',
}));

const StyledButton = styled(Button)(() => ({
  color: alpha(AdditionalColors.Black, 0.47),
  fontSize: '12px',
  fontWeight: 700,
  textTransform: 'none',
  letterSpacing: 'normal',
  padding: 0,
  lineHeight: 0,

  '&:hover': {
    backgroundColor: 'inherit',
  },
}));

const StyledUnfoldLess = styled(UnfoldLess)(() => ({
  color: alpha(AdditionalColors.Black, 0.47),
  transform: 'rotate(45deg)',
  position: 'absolute',
  top: '5px',
  right: '5px',
}));

interface Props {
  onShrink: () => void;
}

export const ExpandedFooter = ({ onShrink }: Props) => {
  const currentYear = new Date().getFullYear();
  return (
    <Container>
      <LeftContainer>
        <MarshMcLennanIcon variant={IconType.Gray} />
        <StyledDescription>
          Marsh McLennan is the leader in risk, strategy and people, helping clients{' '}
          <br />
          navigate a dynamic environment through four global businesses
        </StyledDescription>
        <PageLinks
          StyledLinkBox={StyledLinkBox}
          StyledLink={StyledLink}
          StyledButton={StyledButton}
        />
        <StyledTypography>© {currentYear} Guy Carpenter</StyledTypography>
      </LeftContainer>

      <StyledUnfoldLess onClick={onShrink} />
    </Container>
  );
};
